import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import layouts from './routes';
import RouteElement from './route-element';
import { LayoutRoute, RouteParams } from 'types/routes/route-params';

const RouterView: React.FC = () => {
    const getRoutes = (allRoutes: Array<LayoutRoute>) => {
        return allRoutes.map((layoutParam: LayoutRoute, index: number) => {
            const { layout: Layout } = layoutParam;
            return (
                <Route
                    key={layoutParam.name + index}
                    element={<Layout {...layoutParam?.layoutProps} />}
                >
                    {layoutParam.routes.map(
                        (routeParams: RouteParams, index: number) => (
                            <Route
                                key={routeParams.name + index}
                                path={routeParams.path}
                                element={<RouteElement {...routeParams} />}
                            />
                        ),
                    )}
                </Route>
            );
        });
    };

    return (
        <Routes>
            {getRoutes(layouts)}
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
};
export default RouterView;
